const license = {
    not_installed: 'Auf dieser Instanz ist keine Lizenz installiert.',
    invalid_key: 'Der Lizenzschlüssel ist ungültig oder wurde manipuliert.',
    expired_key: 'Der Lizenzschlüssel ist abgelaufen. Hole einen neuen Schlüssel und installiere ihn erneut.',
};
export default Object.freeze(license);
